<script>
import formatPrice, { formatPriceRange } from "@utils/format-price";
import { getOption } from "@utils/ipetbooking-options";
import { authComputed, merchantComputed } from "@store/helpers";
import formatCurrency from "@utils/format-currency";
import { memberLevelPriceDiscount } from "@utils/ipetbooking-level";

export default {
  props: {
    type: {
      type: String,
      default: 'cat',
      validator(value) {
        return [
          'cat',
          'dog',
        ].includes(value)
      },
    },
    prepaidItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      submitData: {
        alias: ''
      },
      showError: false,
      loadingStoreCart: false
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    prepaidItemSizeOptions() {
      return this.prepaidItem.priceTable.map(item => {
        return {
          ...item,
          text: item.sizeTitle,
          value: item.alias
        }
      })
    },
    priceItem() {
      return getOption({
        options: this.prepaidItemSizeOptions,
        value: this.submitData.alias,
      }) || {}
    },
  },
  methods: {
    formatPrice,
    formatPriceRange,
    formatCurrency,
    memberLevelPriceDiscount,
    async onSubmit() {
      const prepaidAlias = this.priceItem.alias;

      const delay = (s) => {
        return new Promise(resolve => {
          setTimeout(resolve,s);
        });
      };

      const loggedInFn = () => {
        this.$nextTick(() => {
          if(this.isBlock) {
            this.$globalDialog('DialogBlock', {})
            return
          }
          const loadingMaskCheckOutCart = this.$loading({
            lock: true,
            text: '正在前往結帳',
            spinner: `fal fa-circle-notch fa-spin`,
            background: 'rgba(81, 176, 202, 0.3)',
            customClass: 'isStyleCheckout'
          });
          this.loadingStoreCart = true;

          this.tryToStoreCart({ prepaidAlias })
            .then(() => {
              const goToPrepaidCheckout = () => {
                this.$router.push({
                  name: 'prepaid-checkout',
                  params: {
                    prepaidAlias
                  }
                });
              };

              goToPrepaidCheckout()
            })
            .catch((e) => {
              if(e.status === 'STATUS_CODE_UNDEFINED') {
                this.$globalDialog('DialogBlock', {})
              }
            })
            .finally(() => {
              this.loadingStoreCart = false;
              loadingMaskCheckOutCart.close()
            })
        });
      };

      this.showError = true;
      this.$refs['observer'].reset();

      await delay(300);
      const valid = await this.$refs['observer'].validate();

      if(valid) {
        if(this.isLoggedIn) {
          loggedInFn()
        } else {
          this.$globalDialog('DialogLogin', {
            callbackLogin: () => {
              loggedInFn()
            }
          })
        }
      }
    },
    async tryToStoreCart({ prepaidAlias }) {
      if(this.$isLoading('storeCart')) {
        return false;
      }

      await this.$store.dispatch('cart/storeCart', {
        prepaidAlias,
      })
        .then(() => {
          return true
        })
    },
  }
}

</script>
<template>
  <div :class="$style.prepaidItemJtails">
    <ValidationObserver ref="observer">
      <el-form
        ref="form"
        :model="submitData"
        label-position="top"
        class="isStylePrepaidJtails"
      >
        <router-link
          :to="{ name: 'prepaid-item', params: { prepaidAlias: prepaidItem.alias }, query: { alias: submitData.alias || undefined } }"
          class="prepaidItemJtails__imageBox"
        >
          <div
            class="prepaidItemJtails__image"
            :style="{ backgroundImage: `url('${ prepaidItem.image || require('@assets/images/default/plan-default-Image@2x.png') }')` }"
          >

          </div>
          <div class="prepaidItemJtails__metaBox">
            <div class="prepaidItemJtails__metaText">
              總抵用次數
            </div>
            <div class="prepaidItemJtails__metaTimes">
              {{ prepaidItem.times }}
            </div>
          </div>
        </router-link>
        <div class="prepaidItemJtails__contentBox">
          <div class="prepaidItemJtails__titleBox">
            <div class="prepaidItemJtails__icon">
              <i :class="`fontello fontello-${type}`"></i>
            </div>
            <div>
              <router-link
                :to="{ name: 'prepaid-item', params: { prepaidAlias: prepaidItem.alias }, query: { alias: submitData.alias || undefined } }"
                class="prepaidItemJtails__title"
              >
                {{ prepaidItem.title }}
              </router-link>
              <div class="prepaidItemJtails__subTitle">
                {{ prepaidItem.subTitle }}
              </div>
            </div>
          </div>
          <BaseStoreTagList
            :store-list="prepaidItem.stores"
            class="mb-3"
          />
          <p
            class="prepaidItemJtails__description"
            v-text="prepaidItem.description"
          ></p>
          <ValidationProvider
            v-slot="{ errors }"
            :rules="'require'"
            name="體型"
          >
            <el-form-item :error="showError && errors[0] ? ' ' : ''" prop="alias">
              <el-select
                ref="alias"
                v-model="submitData.alias"
                placeholder="請選擇體型"
              >
                <el-option
                  v-for="(option, $index) in prepaidItemSizeOptions"
                  :key="`prepaidItemSizeOptions-${$index}`"
                  :label="option.text"
                  :value="option.value">
                  <div>
                    {{ option.text }} <span class="text-gray-2">{{ formatPrice(option.price) }}</span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
          </ValidationProvider>
          <div class="prepaidItemJtails__price">
            <template v-if="!!submitData.alias">
              {{  priceItem.levelDiscount > 0   
                ? `會員價NT$ ${formatCurrency(memberLevelPriceDiscount(priceItem.price, priceItem))}`
                : formatPrice(priceItem.price) 
              }}
              <br v-if="priceItem.levelDiscount > 0" class="d-md-none">
              <span
                v-if="priceItem.levelDiscount > 0"
                class="prepaidItemJtails__basePrice"
              >
                售價NT$ {{ formatCurrency(priceItem.price) }}
              </span>
              <span
                v-if="priceItem.price < priceItem.basePrice && !priceItem.levelDiscount > 0"
                class="prepaidItemJtails__basePrice"
              >
                原價NT$ {{ formatCurrency(priceItem.basePrice) }}
              </span>
            </template>
            <template v-else>
              {{ formatPriceRange(prepaidItem.minPrice, prepaidItem.maxPrice) }}
            </template>
          </div>
        </div>
        <div class="prepaidItemJtails__submit">
          <BaseButton
            :loading="loadingStoreCart"
            class="isStyleSecondary isFull isBig"
            @click="onSubmit"
          >
            立即購買
          </BaseButton>
        </div>
      </el-form>
    </ValidationObserver>
    <BasePre>{{ prepaidItem }}</BasePre>
  </div>
</template>
<style lang="scss" module>
.prepaidItemJtails {
  border: 0.8px solid $color-line;

  :global {
    .prepaidItemJtails {
      &__imageBox {
        position: relative;
        display: block;
        padding-top: 48.5%;
        margin: -1px -1px 0.75rem -1px;
        overflow: hidden;
        cursor: pointer;
      }

      &__image {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: $color-bg-default;
        background-position: center;
        background-size: cover;
        transition: transform 0.3s;
        transform: scale(1);

        &:hover {
          transform: scale(1.15);
        }
      }

      &__metaBox {
        position: absolute;
        right: 0;
        bottom: 0;
        padding: 0.5rem 2rem;
        color: #fff;
        text-align: right;
        background: rgba($color-primary, 0.9);
      }

      &__metaText {
        font-size: 0.875rem;
      }

      &__metaTimes {
        font-family: $font-number;
        font-weight: 700;
      }

      &__contentBox {
        padding: 1rem 2rem 1.5rem;
      }

      &__titleBox {
        display: flex;
        align-items: center;
        margin-bottom: 0.25rem;
      }

      &__icon {
        margin-top: -0.25em;
        margin-right: 0.5rem;
        font-size: 3rem;
        color: $color-primary;
      }

      &__title {
        display: block;
        font-family: $font-serif;
        font-size: 1.25rem;
        font-weight: 600;
        color: $color-primary-dark;
        letter-spacing: 0.2em;
        transition: color 0.3s;

        &:hover {
          color: $color-primary;
          cursor: pointer;
        }
      }

      &__subTitle {
        font-size: 0.875rem;
        color: #726F65;
      }

      &__description {
        min-height: 15rem;
        font-size: 0.875rem;
        line-height: 1.75;
        color: #726F65;
        white-space: pre-wrap;
      }

      &__price {
        font-family: $font-number;
        font-size: 1.5rem;
        font-weight: 500;
        color: $color-primary;
      }

      &__submit {
        margin: 0 -1px -1px -1px;
      }
      &__basePrice {
        margin-left: 0.25rem;
        font-family: $font-number;
        font-size: 0.75rem;
        color: $color-gray-2;
        text-decoration: line-through;
      }
    }
  }
}
</style>
